import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { FolderContainer, Fold, FoldContentContainer } from '@bit/knotchinc.web-react-components.container-card';
import { ContentCardContainer } from 'components/Global/Card/styled.js';
import { TopDataContainer } from './TrendingLists/styled';
/* CONTAINERS */
export const ContentFeedContainer = styled.div`
  display: block;
  width: 100%;

  ${ContentCardContainer} {
    width: ${({ theme }) => theme.cardWidths.half};
    height: 400px;

    @media (min-width: 1100px) {
      width: ${({ theme }) => theme.cardWidths.third};
      height: 355px;
    }

    @media (min-width: 1300px) {
      width: ${({ theme }) => theme.cardWidths.third};
      height: 360px;
    }

    @media (min-width: 1500px) {
      width: ${({ theme }) => theme.cardWidths.fourth};
      height: 370px;
    }
  }
`;

export const EntityFeedContainer = styled.div`
  display: block;
  width: 100%;

  ${ContentCardContainer} {
    height: 300px;
    vertical-align: top;
    width: ${({ theme }) => theme.cardWidths.half};

    &:nth-child(1) {
      width: 100%;
    }

    @media (min-width: 1300px) {
      height: 400px;
    }
  }
`;

export const FolderCardFeedContainer = styled.div`
  display: block;
  width: 100%;

  ${FolderContainer} {
    width: ${({ theme }) => theme.cardWidths.half};
    height: 270px;

    @media (min-width: 1300px) {
      width: ${({ theme }) => theme.cardWidths.third};
      height: 300px;
    }

    @media (min-width: 1500px) {
      width: ${({ theme }) => theme.cardWidths.third};
      height: 340px;
    }
  }

  ${Fold} {
    height: 150px;
    > div {
      height: 150px;
    }
  }

  ${FoldContentContainer} {
    height: 150px;
  }
`;

export const EntityLabelContainer = styled.div`
  height: 50px;
  margin-bottom: 12px;
`;

export const EntitySection = styled.div`
  display: inline-block;
  width: 49%;
  margin-bottom: 50px;
  vertical-align: top;

  &:nth-child(2n+1) {
    margin-right: 2%;
  }
`;

export const TrendingListsContainer = styled.div`
  margin-top: -196px;
  display: block;
  width: 100%;
  height: 260px;
  margin-bottom: 40px;
  text-align: center;

  & ${TopDataContainer}:nth-child(1) {
    margin-left: 0;
  }

  & ${TopDataContainer}:nth-child(3) {
    margin-right: 0;
  }
`;

/* ICONS */
export const StyledEntityIcon = styled(Link)`
  vertical-align: middle;
  background-image: ${({ logo_url }) => `url('${logo_url}')`};
  width: 50px;
  height: 50px;
  border-radius: 100%;
  background-color: white;
  float: left;
  margin-left: 8px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  transform: scale(1);
  will-change: transform;
  transition: all .15s ease;
  box-shadow: 0px 6px 6px rgba(0,0,0,0.05);
  cursor: pointer;

  &:hover {
    transform: scale(1.03);
  }

`;

/* TEXT ELEMENTS */
export const StyledProfileSubtitle = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 17px;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.palette[5]};
  margin-left: 8px;
`;

export const StyledEntityName = styled(Link)`
  display: inline-block;
  font-size: 18px;
  line-height: 28px;
  margin-left: 20px;
  margin-right: 10px;
  color: #1F222B;

  &:hover {
    text-decoration: underline;
  }
`;

export const StyledEntityTypeLabel = styled.div`
  display: block;
  margin-left: 78px;
  font-size: 12px;
  line-height: 17px;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.palette[5]};
`;

export const StyledSubscribeLabel = styled.div`
  display: inline-block;
  width: 81px;
  height: 18px;
  font-weight: 500;
  font-size: 10px;
  text-align: center;
  border-radius: 5px;
  text-transform: uppercase;
  padding: 3px 5px;
  vertical-align: middle;
  letter-spacing: 0.05em;
  color: ${({ theme }) => theme.colors.palette[7]};
  background: #DCE8F3;
  position: relative;
  top: -2px;
`;
